import { Model as r } from "../../../../../model.js";
class c extends r {
  constructor(e) {
    super(), this.programmeType = e.programmeType, this.currencyName = e.currencyName;
  }
}
export {
  c as LoyaltyProgrammeSettingsModel
};
//# sourceMappingURL=loyaltyProgrammeSettings.model.js.map
